import axios from 'axios';

import { addNotification, NotificationImportance } from '../store/common/commonActions';

// POST d'un interlocuteurSAV, sans utilisation du store (sauf pour les notifications)
export const postInterlocuteurSAV = (interlocuteurSAV) => async (dispatch) => {

    try {
        let response = await axios.post(`api/interlocuteursSAV/`, interlocuteurSAV);


        dispatch(addNotification(`Assignation du codePO ${interlocuteurSAV.codePOInterlocuteurSAV} au ${interlocuteurSAV.type === 0 ? 'magasin' : 'département'} ${interlocuteurSAV.code} avec succès.`, NotificationImportance.success));

        return response.data;
    } catch (error) {
        console.error('postInterlocuteurSAV : ', error);

        dispatch(addNotification(`Impossible d'assigner le codePO ${interlocuteurSAV.codePOInterlocuteurSAV} au ${interlocuteurSAV.type === 0 ? 'magasin' : 'département'} ${interlocuteurSAV.code}.`, NotificationImportance.error));

        return error;
    }
};


// DELETE d'un interlocuteurSAV, sans utilisation du store (sauf pour les notifications)
export const deleteInterlocuteurSAV = (interlocuteurSAV) => async (dispatch) => {

    try {
        let response = await axios.delete(`api/interlocuteursSAV/${interlocuteurSAV.id}`);


        dispatch(addNotification(`Suppression du codePO ${interlocuteurSAV.codePOInterlocuteurSAV} sur le ${interlocuteurSAV.type === 0 ? 'magasin' : 'département'} ${interlocuteurSAV.code} avec succès.`, NotificationImportance.success));

        return response.data;
    } catch (error) {
        console.error('deleteInterlocuteurSAV : ', error);

        dispatch(addNotification(`Impossible de supprimer le codePO ${interlocuteurSAV.codePOInterlocuteurSAV} au ${interlocuteurSAV.type === 0 ? 'magasin' : 'département'} ${interlocuteurSAV.code}.`, NotificationImportance.error));

        return error;
    }
};



// POST d'un contrôle de l'éligibilité d'une pièce au retour volontaire avec la saisie de l'utilisateur
export const controlerEligibiliteRetourVolontaire = (numeroPiece, lignes, typePiece = null) => async (dispatch) => {

    // DEV-4012 : typePiece indique au back si numeroPiece est une clé BL ou de commande (mode RV depuis commande).
    let param = { lignes, typePiece };

    try {
        let response = await axios.post(`api/pieces-gestion/${numeroPiece}/controler-eligibilite-retour-volontaire`, param);

        return response.data;
    } catch (error) {
        console.error('controlerEligibiliteRetourVolontaire : ', error);

        dispatch(addNotification(`Erreur lors du contrôle de l'éligibilité d'un retour volontaire sur la pièce ${numeroPiece}`, NotificationImportance.error));

        return error;
    }

};



// POST d'un frais de retour, sans utilisation du store (sauf pour les notifications)
export const postFraisRetour = (fraisRetour) => async (dispatch) => {

    console.error('postFraisRetour : ', fraisRetour);

    try {
        await axios.post(`api/frais-retour/`, fraisRetour);


        dispatch(addNotification(`Enregistrement du frais de retour code ${fraisRetour.code}, libellé ${fraisRetour.libelle}, codeArticle ${fraisRetour.codeArticle} avec un montant de ${fraisRetour.montant.toFixed(2)} avec succès.`, NotificationImportance.success));

        //return response.data;
        return true;
    } catch (error) {
        console.error('postFraisRetour : ', error);

        dispatch(addNotification(`Impossible d'enregistrer le frais de retour code: ${fraisRetour.code}, libellé ${fraisRetour.libelle}, codeArticle ${fraisRetour.codeArticle} avec un montant de ${fraisRetour.montant.toFixed(2)} €.`, NotificationImportance.error));

        //return error;
        return false;
    }
};



// PATCH du mail de suivi SAV BY FOUSSIER d'un fournisseur, sans utilisation du store (sauf pour les notifications)
export const patchFournisseurEmailSuiviSAVByFoussier = (fournisseur) => async (dispatch) => {

    const param = { emailSuiviSAVByFoussier: fournisseur.emailSuiviSAVByFoussier };

    try {
        await axios.patch(`api/fournisseurs/${fournisseur.id}`, param);


        dispatch(addNotification(`Enregistrement du fournisseur ${fournisseur.id} avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('patchFournisseurEmailSuiviSAVByFoussier : ', error);

        dispatch(addNotification(`Impossible d'enregistrer le fournisseur: ${fournisseur.id}.`, NotificationImportance.error));

        return false;
    }
};

// PATCH du flag PreuveAchatObligatoire d'un fournisseur, sans utilisation du store (sauf pour les notifications)
export const patchFournisseurPreuveAchatObligatoire = (fournisseur) => async (dispatch) => {

    const param = { preuveAchatObligatoire: fournisseur.preuveAchatObligatoire };

    try {
        await axios.patch(`api/fournisseurs/${fournisseur.id}`, param);


        dispatch(addNotification(`Enregistrement du fournisseur ${fournisseur.id} avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('patchFournisseurPreuveAchatObligatoire : ', error);

        dispatch(addNotification(`Impossible d'enregistrer le fournisseur: ${fournisseur.id}.`, NotificationImportance.error));

        return false;
    }
};


// POST du mail à sav-info@foussier.fr depuis un formulaire
export const postEnvoiMailServiceAchat = (fournisseurId, message) => async (dispatch) => {

    // console.log('postEnvoiMailServiceAchat : ', fournisseurId, message);

    let param = { message };

    try {
        await axios.post(`api/fournisseurs/${fournisseurId}/envoyer-mail`, param);

        dispatch(addNotification(`Email envoyé avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('postEnvoiMailServiceAchat : ', error);

        dispatch(addNotification(`Impossible d'envoyer le mail`, NotificationImportance.error));

        return false;
    }
};


// PATCH du code siège (numéro fournisseur pour étiquette), sans utilisation du store (sauf pour les notifications)
export const patchFournisseurCodeSiegeEtiquette = (fournisseur) => async (dispatch) => {

    console.error('patchFournisseurCodeSiegeEtiquette : ', fournisseur);

    const param = { codeSiege: fournisseur.codeSiege };

    try {
        await axios.patch(`api/fournisseurs/${fournisseur.id}`, param);

        dispatch(addNotification(`Enregistrement du fournisseur ${fournisseur.id} avec succès.`, NotificationImportance.success));

        return true;

    } catch (error) {
        console.error('patchFournisseurCodeSiegeEtiquette : ', error);

        dispatch(addNotification(`Impossible d'enregistrer le fournisseur: ${fournisseur.id}.`, NotificationImportance.error));

        return false;
    }
};


// POST d'un utilisateur dans l'admin, sans utilisation du store (sauf pour les notifications)
export const patchAdministrationUtilisateur = (id, exclusionControleAgePiece) => async (dispatch) => {

    console.error('patchAdministrationUtilisateur : ', id);

    const param = { exclusionControleAgePiece: exclusionControleAgePiece };

    try {
        await axios.patch(`api/utilisateurs/administration/${id}`, param);

        dispatch(addNotification(`Enregistrement de l'utilisateur ${id} avec succès.`, NotificationImportance.success));

        return true;

    } catch (error) {
        console.error('patchAdministrationUtilisateur : ', error);

        dispatch(addNotification(`Impossible d'enregistrer l'utilisateur: ${id}.`, NotificationImportance.error));

        return false;
    }
};


// POST d'un contrôle de l'éligibilité d'une pièce au retour volontaire avec la saisie de l'utilisateur
export const controlerArticlesPLVRetourVolontaire = (numeroPiece, lignes, codeDepot, typePiece = null) => async (dispatch) => {

    // DEV-4012 : typePiece indique au back si numeroPiece est une clé BL ou de commande (mode RV depuis commande).
    let param = { lignes, codeDepot, typePiece };

    try {
        let response = await axios.post(`api/pieces-gestion/${numeroPiece}/controler-articles-plv-retour-volontaire`, param);

        return response.data;
    } catch (error) {
        console.error('controlerArticlesPLVRetourVolontaire : ', error);

        dispatch(addNotification(`Erreur lors du contrôle des articles dans le plv du magasin d'un retour volontaire sur la pièce ${numeroPiece}`, NotificationImportance.error));

        return error;
    }
};


// DELETE d'un élément paramétré dans l'arborescence, sans utilisation du store (sauf pour les notifications)
export const deleteElementParametreArborescence = (niveau, code, parametre) => async (dispatch) => {

    try {
        await axios.delete(`api/arborescence-gestion/elements-parametres/${niveau}/${code}/${parametre.valeur}`);

        dispatch(addNotification(`Suppression de l'élément paramétré : niveau ${niveau} code ${code} paramètre ${parametre.libelle} avec succès.`, NotificationImportance.success));

        return true;

    } catch (error) {
        console.error('deleteElementParametreArborescence : ', error);

        dispatch(addNotification(`Impossible de supprimer l'élément paramétré : niveau ${niveau} code ${code} paramètre ${parametre.libelle}`, NotificationImportance.error));

        return false;
    }
};

// POST d'un contrôle de l'éligibilité d'une pièce au retour volontaire avec la saisie de l'utilisateur
export const addElementParametreArborescence = (niveau, code, parametre) => async (dispatch) => {

    let param = { niveau, code, parametre: parametre.valeur };

    try {
        let response = await axios.post(`api/arborescence-gestion/elements-parametres`, param);

        if (response.data) {
            dispatch(addNotification(`Ajout de l'élément paramétré : ${niveau} / ${code} / ${parametre.libelle} avec succès`, NotificationImportance.success));

        } else {
            dispatch(addNotification(`Erreur lors de l'ajout, l'élément paramétré : ${niveau} / ${code} / ${parametre.libelle} existe déjà`, NotificationImportance.warning));
        }

        return response.data;

    } catch (error) {
        console.error('addElementParametreArborescence : ', error);

        dispatch(addNotification(`Erreur lors de l'ajout d'un élément paramétré de l'arborescence : ${niveau} / ${code} / ${parametre.libelle}`, NotificationImportance.error));

        return false;
    }
};




//░█▀▀░█▀█░▀█▀░█▀▀░█▀▀░█▀█░█▀▄░▀█▀░█▀▀░█▀▀
//░█░░░█▀█░░█░░█▀▀░█░█░█░█░█▀▄░░█░░█▀▀░▀▀█
//░▀▀▀░▀░▀░░▀░░▀▀▀░▀▀▀░▀▀▀░▀░▀░▀▀▀░▀▀▀░▀▀▀

// POST d'une categorie SAV, sans utilisation du store (sauf pour les notifications)
export const postSAVCategorie = (categorie) => async (dispatch) => {

    console.error('postSAVCategorie : ', categorie);

    try {
        let response = await axios.post(`api/sav-categories/`, categorie);


        dispatch(addNotification(`Enregistrement de la catégorie SAV libellé "${categorie.libelle}" avec succès.`, NotificationImportance.success));

        //return response.data;
        return { error: false, categorie: response.data };
    } catch (error) {
        console.error('postSAVCategorie : ', error);

        dispatch(addNotification(`Impossible d'enregistrer la catégorie : libellé "${categorie.libelle}".`, NotificationImportance.error));

        //return error;
        return { error: true, categorie: null };
    }
};

// DELETE d'une catégorie SAV, sans utilisation du store (sauf pour les notifications)
export const deleteSAVCategorie = (categorie) => async (dispatch) => {

    try {
        let response = await axios.delete(`api/sav-categories/${categorie.id}`);


        dispatch(addNotification(`Suppression de la catégorie "${categorie.id} - ${categorie.libelle}" avec succès.`, NotificationImportance.success));

        return response.data;
    } catch (error) {
        console.error('deleteSAVCategorie : ', error);

        dispatch(addNotification(`Impossible de supprimer la catégorie "${categorie.id} - ${categorie.libelle}".`, NotificationImportance.error));

        return error;
    }
};

// PATCH d'une catégorie SAV, sans utilisation du store (sauf pour les notifications)
export const patchSAVCategorie = (categorie) => async (dispatch) => {

    console.error('patchSAVCategorie : ', categorie);

    const param = { libelle: categorie.libelle };

    try {
        await axios.patch(`api/sav-categories/${categorie.id}`, param);


        dispatch(addNotification(`Enregistrement de la catégorie SAV "${categorie.id} - ${categorie.libelle}" avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('patchSAVCategorie : ', error);

        dispatch(addNotification(`Impossible d'enregistrer la catégorie SAV: ${categorie.id}.`, NotificationImportance.error));

        return false;
    }
};


//░█▀▀░█▀█░█░█░█▀▄░█▀█░▀█▀░█▀▀░█▀▀░█▀▀░█░█░█▀▄░█▀▀
//░█▀▀░█░█░█░█░█▀▄░█░█░░█░░▀▀█░▀▀█░█▀▀░█░█░█▀▄░▀▀█
//░▀░░░▀▀▀░▀▀▀░▀░▀░▀░▀░▀▀▀░▀▀▀░▀▀▀░▀▀▀░▀▀▀░▀░▀░▀▀▀

// POST d'une liaison SAV fournisseur / dépôt, sans utilisation du store (sauf pour les notifications)
export const postSAVFournisseurDepot = (fournisseurDepot) => async (dispatch) => {

    console.log('postSAVFournisseurDepot : ', fournisseurDepot);

    let param = {
        codeDepot: fournisseurDepot.depot.codeDepot,
        numeroCompte: fournisseurDepot.numeroCompte,
        email: fournisseurDepot.email,
        codeAgence: fournisseurDepot.codeAgence
    }
    console.log('postSAVFournisseurDepot param : ', param);

    try {
        let response = await axios.post(`api/sav-fournisseurs/${fournisseurDepot.fournisseur.id}/depot`, param);

        dispatch(addNotification(`Enregistrement de la liaison fournisseur / dépôt "${fournisseurDepot.fournisseur.nom}" / "${fournisseurDepot.depot.nom}"`, NotificationImportance.success));

        return true;
        //return { error: false, categorie: response.data };
    } catch (error) {
        console.error('postSAVFournisseurDepot : ', error);

        dispatch(addNotification(`Impossible d'enregistrer la liaison fournisseur / dépôt "${fournisseurDepot.fournisseur.nom}" / "${fournisseurDepot.depot.nom}"`, NotificationImportance.error));

        return false;
        //return { error: true, categorie: null };
    }
};

// POST des liaison SAV fournisseur / dépôts, sans utilisation du store (sauf pour les notifications)
export const postSAVFournisseurDepots = (fournisseur) => async (dispatch) => {

    console.log('postSAVFournisseurDepots : ', fournisseur);

    let param = {
        depots: fournisseur.liaisons.map(l => {
            let depot =
            {
                codeDepot: l.depot.codeDepot,
                numeroCompte: l.numeroCompte,
                email: l.email
            };
            return depot;
        })
    };

    console.log('postSAVFournisseurDepots param : ', param);

    try {
        let response = await axios.post(`api/sav-fournisseurs/${fournisseur.id}/depots`, param);


        dispatch(addNotification(`Enregistrement du fournisseur "${fournisseur.nom}"`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('postSAVFournisseurDepots : ', error);

        dispatch(addNotification(`Impossible d'enregistrer le fournisseur "${fournisseur.nom}"`, NotificationImportance.error));

        return false;
    }
};

// DELETE d'un SAV fournisseur sur un dépôt, sans utilisation du store (sauf pour les notifications)
export const deleteSAVFournisseurDepot = (fournisseurDepot) => async (dispatch) => {

    console.error('deleteSAVFournisseurDepot : ', fournisseurDepot);


    try {
        let response = await axios.delete(`api/sav-fournisseurs/${fournisseurDepot.fournisseur.id}/depot/${fournisseurDepot.depot.codeDepot}`);


        dispatch(addNotification(`Suppression du fournisseur "${fournisseurDepot.fournisseur.nom}" sur le dépot "${fournisseurDepot.depot.codeDepot}"`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('deleteSAVFournisseurDepot : ', error);

        dispatch(addNotification(`Impossible de supprimer fournisseur "${fournisseurDepot.fournisseur.nom}" sur le dépot "${fournisseurDepot.depot.codeDepot}"`, NotificationImportance.error));

        return false;
    }
};

// DELETE d'un SAV fournisseur sur tous les dépôts, sans utilisation du store (sauf pour les notifications)
export const deleteSAVFournisseurDepots = (fournisseur) => async (dispatch) => {

    console.error('deleteSAVFournisseurDepots : ', fournisseur);


    try {
        let response = await axios.delete(`api/sav-fournisseurs/${fournisseur.id}/depots`);


        dispatch(addNotification(`Suppression du fournisseur "${fournisseur.nom}"`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('deleteSAVFournisseurDepots : ', error);

        dispatch(addNotification(`Impossible de supprimer fournisseur "${fournisseur.nom}"`, NotificationImportance.error));

        return false;
    }
};



// POST d'une liaison SAV fournisseur / client, sans utilisation du store (sauf pour les notifications)
export const postSAVFournisseurClient = (fournisseurClient) => async (dispatch) => {

    console.error('postSAVFournisseurClient : ', fournisseurClient);

    let param = {
        clientId: fournisseurClient.client.id,
        numeroCompte: fournisseurClient.numeroCompte
    }
    console.error('postSAVFournisseurClient param : ', param);

    try {
        let response = await axios.post(`api/sav-fournisseurs/${fournisseurClient.fournisseur.id}/clients/${fournisseurClient.client.id}`, param);


        dispatch(addNotification(`Enregistrement de la liaison fournisseur / client "${fournisseurClient.fournisseur.nom}" / "${fournisseurClient.client.nom}"`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('postSAVFournisseurClient : ', error);

        dispatch(addNotification(`Impossible d'enregistrer la liaison fournisseur / client "${fournisseurClient.fournisseur.nom}" / "${fournisseurClient.client.nom}"`, NotificationImportance.error));

        return false;
    }
};

// DELETE d'un SAV fournisseur sur un client, sans utilisation du store (sauf pour les notifications)
export const deleteSAVFournisseurClient = (fournisseurClient) => async (dispatch) => {

    console.error('deleteSAVFournisseurClient : ', fournisseurClient);


    try {
        let response = await axios.delete(`api/sav-fournisseurs/${fournisseurClient.fournisseur.id}/clients/${fournisseurClient.client.id}`);


        dispatch(addNotification(`Suppression du fournisseur "${fournisseurClient.fournisseur.nom}" sur le client "${fournisseurClient.client.libelle}"`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('deleteSAVFournisseurClient : ', error);

        dispatch(addNotification(`Impossible de supprimer fournisseur "${fournisseurClient.fournisseur.nom}" sur le client "${fournisseurClient.client.libelle}"`, NotificationImportance.error));

        return false;
    }
};


//░█▄█░█▀█░█▀▄░▄▀▄░█░█░█▀▀░█▀▀
//░█░█░█▀█░█▀▄░█\█░█░█░█▀▀░▀▀█
//░▀░▀░▀░▀░▀░▀░░▀\░▀▀▀░▀▀▀░▀▀▀

// POST d'une marque, sans utilisation du store (sauf pour les notifications)
export const postMarque = (marque) => async (dispatch) => {

    console.error('postMarque : ', marque);

    try {
        let response = await axios.post(`api/marques/`, marque);


        dispatch(addNotification(`Enregistrement de la marque "${marque.nom}" avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('postMarque : ', error);

        dispatch(addNotification(`Impossible d'enregistrer la marque : "${marque.nom}".`, NotificationImportance.error));

        return false;
    }
};

// PATCH d'une marque, sans utilisation du store (sauf pour les notifications)
export const patchMarque = (marque) => async (dispatch) => {

    console.error('patchMarque : ', marque);

    let param = {
        nom: marque.nouveauNom,
        marquePropre: marque.marquePropre,
        fournisseursIds: marque.fournisseurs.map(f => f.id)
    };

    console.error('patchMarque : param : ', param);

    try {
        let response = await axios.patch(`api/marques/${marque.id}`, param);


        dispatch(addNotification(`Modification de la marque "${marque.nom}" avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('patchMarque : ', error);

        dispatch(addNotification(`Impossible de modifier la marque : "${marque.nom}".`, NotificationImportance.error));

        return false;
    }
};

// DELETE d'une marque, sans utilisation du store (sauf pour les notifications)
export const deleteMarque = (marque) => async (dispatch) => {

    try {
        let response = await axios.delete(`api/marques/${marque.id}`);


        dispatch(addNotification(`Suppression de la marque "${marque.id} - ${marque.nom}" avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('deleteSAVCategorie : ', error);

        dispatch(addNotification(`Impossible de supprimer la marque "${marque.id} - ${marque.nom}".`, NotificationImportance.error));

        return false;
    }
};



//░█▀█░█▀█░█▀▄░█▀█░█▄█░█▀▀░▀█▀░█▀▄░█▀▀░█▀▀
//░█▀▀░█▀█░█▀▄░█▀█░█░█░█▀▀░░█░░█▀▄░█▀▀░▀▀█
//░▀░░░▀░▀░▀░▀░▀░▀░▀░▀░▀▀▀░░▀░░▀░▀░▀▀▀░▀▀▀

// PATCH d'un parametre, sans utilisation du store (sauf pour les notifications)
export const patchParametre = (parametre) => async (dispatch) => {

    //console.log('patchParametre : ', parametre);

    let param = {
        valeur: parametre.valeur,
    };

    //console.log('patchParametre : param : ', param);

    try {
        let response = await axios.patch(`api/parametres/${parametre.code}`, param);


        dispatch(addNotification(`Modification du paramètre "${parametre.code}" avec succès.`, NotificationImportance.success));

        return true;
    } catch (error) {
        console.error('patchParametre : ', error);

        dispatch(addNotification(`Impossible de modifier le parametre : "${parametre.code}".`, NotificationImportance.error));

        return false;
    }
};



//░█▀▄░█▀▀░▀█▀░█▀█░█░█░█▀▄░█▀▀░░░█▀▀░█░█░█▀▀░█░░░█░█░█▀▀
//░█▀▄░█▀▀░░█░░█░█░█░█░█▀▄░▀▀█░░░█▀▀░░█░░█░░░█░░░█░█░▀▀█
//░▀░▀░▀▀▀░░▀░░▀▀▀░▀▀▀░▀░▀░▀▀▀░░░▀▀▀░▀░▀░▀▀▀░▀▀▀░▀▀▀░▀▀▀

// DELETE d'un montant mini retour exclu, sans utilisation du store (sauf pour les notifications)
export const deleteMontantMiniRetourExclu = (montantMini, niveau) => async (dispatch) => {

    try {
        let response = await axios.delete(`api/montantMiniRetourExclus/${montantMini.id}`);

        dispatch(addNotification(`Suppression de l'exclusion avec le niveau "${niveau.libelle}" et le code "${montantMini.code}".`, NotificationImportance.success));

        return true;

    } catch (error) {
        console.error('deleteMontantMiniRetourExclu : ', error);

        dispatch(addNotification(`Impossible de supprimer l'exclusion avec le niveau "${niveau.libelle}" et le code "${montantMini.code}".`, NotificationImportance.error));

        return false;
    }
};

// POST d'un montant mini retour exclu, sans utilisation du store (sauf pour les notifications)
export const postMontantMiniRetourExclu = (code, niveau) => async (dispatch) => {
    let montantMini = {
        code: code,
        niveau: niveau.id
    }

    try {

        let response = await axios.post(`api/montantMiniRetourExclus/`, montantMini);

        dispatch(addNotification(`L'exclusion pour le niveau "${niveau.libelle}" et le code "${montantMini.code}", a bien été ajouté.`, NotificationImportance.success));

        return true;

    } catch (error) {
        console.error('postMontantMini : ', error);

        dispatch(addNotification(`Impossible d'ajouter l'exclusion pour le niveau "${niveau.libelle}" et le code "${montantMini.code}".`, NotificationImportance.error));

        return false;
    }
};
